import React, { Component } from 'react';
import { withTranslation, TFunction } from 'react-i18next';
import { connect } from 'react-redux';
import { ArrowLeft } from '../../../assets/icons';
import './BookMakeUpSessionPage.css';

// Redux Actions
import GetCheckAvailableActions from '../../../redux/GetCheckAvailableRedux';
import CreateMakeUpSessionActions from '../../../redux/CreateMakeUpSessionRedux';
import { isValidValue } from '../../../utils/Helpers';

// Navigation parameters interface
interface BookMakeUpSessionPageProps {
  t?: TFunction;
  navigate?: (path: string, params?: any) => void;
  goBack?: () => void;
  
  // Navigation parameters (from URL query strings)
  leave_id?: string | null;
  categoryId?: string | null;
  code?: string | null;
  isStudent?: boolean;
  isTherapist?: boolean;
  isReschedule?: boolean;
  make_id?: string | null;
  therapist_leave_id?: string | null;
  paramsForUpdateMake?: any;
  
  // Location object for URL parameters
  location?: {
    search: string;
    pathname: string;
  };
  
  // Redux Props
  currentSettings?: any;
  getCheckAvailableFetching?: boolean;
  getCheckAvailableSuccess?: boolean;
  getCheckAvailableError?: boolean;
  checkAvailable?: any;
  makedata?: any;
  
  // Redux Actions
  getCheckAvailable?: (
    leave_id: string,
    student_id: string,
    isTherapist: boolean,
    isReschedule: boolean,
    make_id: string,
    therapist_leave_id: string
  ) => void;
  createMakeUpSession?: (children_id: string) => void;
}

interface BookMakeUpSessionPageState {
  radioButton: number;
  isStudent: boolean;
  isTherapist: boolean;
  isReschedule: boolean;
  loading: boolean;
}

class BookMakeUpSessionPage extends Component<BookMakeUpSessionPageProps, BookMakeUpSessionPageState> {
  constructor(props: BookMakeUpSessionPageProps) {
    super(props);
    
    this.state = {
      radioButton: 0,
      isStudent: this.props.isStudent || false,
      isTherapist: this.props.isTherapist || false,
      isReschedule: this.props.isReschedule || false,
      loading: false,
    };
  }

  // Utility function to parse URL parameters
  parseUrlParams = () => {
    // Return props directly since wrapper now handles URL parsing
    return {
      leave_id: this.props.leave_id,
      categoryId: this.props.categoryId,
      code: this.props.code,
      isStudent: this.props.isStudent,
      isTherapist: this.props.isTherapist,
      isReschedule: this.props.isReschedule,
      make_id: this.props.make_id,
      therapist_leave_id: this.props.therapist_leave_id,
      paramsForUpdateMake: this.props.paramsForUpdateMake
    };
  }

  componentDidMount() {
    // Use props directly since wrapper handles URL parsing
    const leave_id = this.props.leave_id;
    const student_id = this.props.currentSettings?.child?.salesforce_contact_id;
    const isTherapist = this.state.isTherapist;
    const isReschedule = this.state.isReschedule;
    const make_id = this.props.make_id;
    const therapist_leave_id = this.props.therapist_leave_id;
    
    // Call API to check available options
    if (leave_id && student_id) {
      this.props.getCheckAvailable?.(
        leave_id,
        student_id,
        isTherapist,
        isReschedule,
        make_id || '',
        therapist_leave_id || ''
      );
    } else {
      console.warn('BookMakeUpSessionPage: Missing required parameters', {
        leave_id,
        student_id,
        hasCurrentSettings: !!this.props.currentSettings,
        hasChild: !!this.props.currentSettings?.child
      });
    }
  }

  // Handle back button
  handleBackPress = () => {
    this.props.goBack?.();
  }

  // Handle next button press
  _onNextPress = () => {
    var paramsForUpdateMake = this.props.paramsForUpdateMake || '';
    try {
      paramsForUpdateMake = JSON.parse(paramsForUpdateMake)
    } catch (error) {
    }
    
    console.log("paramsForUpdateMake.... in selected", paramsForUpdateMake);
    
    // Note: updateMake call is commented out in reference implementation
    // this.props.updateMake?.(
    //   paramsForUpdateMake.selected,
    //   paramsForUpdateMake.make
    // );
    
    const isValidLeaveIdExist = isValidValue(this.props.leave_id);
    const isValidTherapistLeaveIdExist = isValidValue(this.props.therapist_leave_id)

    const categoryId = this.props.categoryId;
    const code = this.props.code;
    const leave_id = isValidLeaveIdExist ? this.props.leave_id : isValidTherapistLeaveIdExist ? this.props.therapist_leave_id : null;
    const isReschedule = paramsForUpdateMake?.make?.isReschedule;
    const make_id_reschedule = paramsForUpdateMake?.make?.make_id;
    const make_id = this.props.makedata?.data?.id || this.props.make_id;
    
    const nameRoutePush = this.state.radioButton === 0 ? 'select-date-and-time' : 'adding-minutes';

    console.log('calendar', {
      categoryId: categoryId,
      code: code,
      leave_id: leave_id,
      make_id: isReschedule ? make_id_reschedule : make_id,
      isStudent: this.state.isStudent,
      isTherapist: this.state.isTherapist || (!isValidLeaveIdExist && isValidTherapistLeaveIdExist),
      isReschedule: isReschedule,
    });

    this.props.navigate?.(`/calendar/${nameRoutePush}`, {
      categoryId: categoryId,
      code: code,
      leave_id: leave_id,
      make_id: isReschedule ? make_id_reschedule : make_id,
      isStudent: this.state.isStudent,
      isTherapist: this.state.isTherapist || (!isValidLeaveIdExist && isValidTherapistLeaveIdExist),
      isReschedule: isReschedule,
    });
  }

  // Handle radio button selection
  handleOptionSelect = (option: number) => {
    this.setState({ radioButton: option });
  }

  render() {
    const { t } = this.props;
    const { radioButton, loading } = this.state;

    // Get URL parameters
    const urlParams = this.parseUrlParams();
    const leave_id = urlParams.leave_id || this.props.leave_id;

    // Show loading state
    const isDataLoading = this.props.getCheckAvailableFetching || false;
    const hasData = this.props.getCheckAvailableSuccess && !this.props.getCheckAvailableFetching && this.props.checkAvailable;
    const hasError = this.props.getCheckAvailableError;

    return (
      <div className="bookmakeupsession-page">
        {/* Header Section */}
        <div className="page-header">
          <div className="page-header-inner">
            <div className="header-left">
              <button
                className="header-button back-button"
                onClick={this.handleBackPress}
              >
                <ArrowLeft />
              </button>
              <h1 className="header-title">
                {t?.('book-make-up-session:select-make-up-option') || 'Select make up option'}
              </h1>
            </div>
            
            <div className="header-right">
              <button
                className="header-button next-button"
                onClick={this._onNextPress}
                disabled={loading}
              >
                <span>
                  {t?.('select-date-and-time-screen:header.right') || 'Next'}
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="page-content">
          {/* Loading State */}
          {/* {isDataLoading && !hasData && !hasError && (
            <div className="loading-card">
              <div className="loading-spinner">
                <span>{t?.('common:loading') || 'Loading...'}</span>
              </div>
            </div>
          )} */}

          {/* Error State */}
          {hasError && (
            <div className="error-card">
              <div className="error-message">
                <span>{t?.('common:error') || 'Error loading data. Please try again.'}</span>
              </div>
            </div>
          )}

          {/* Option 1 - Book New Make-up Session */}
          <div 
            className={`option-card ${radioButton === 0 ? 'selected' : ''}`}
            onClick={() => this.handleOptionSelect(0)}
          >
            <div className="option-content">
              <span className="option-text">
                {t?.('make-up-session:option-one') || 'Book a new make-up session'}
              </span>
            </div>
            <div className="option-radio">
              {radioButton === 0 ? (
                <div className="radio-selected" />
              ) : (
                <div className="radio-unselected" />
              )}
            </div>
          </div>

          {/* Option 2 - Add Minutes (Conditional) */}
          {this.props.checkAvailable?.data?.allow_option_two === true ? (
            <div 
              className={`option-card ${radioButton === 1 ? 'selected' : ''}`}
              onClick={() => this.handleOptionSelect(1)}
            >
              <div className="option-content">
                <span className="option-text">
                  {t?.('make-up-session:option-two') || 'Add minutes to existing session'}
                </span>
              </div>
              <div className="option-radio">
                {radioButton === 1 ? (
                  <div className="radio-selected" />
                ) : (
                  <div className="radio-unselected" />
                )}
              </div>
            </div>
          ) : null}

          
        </div>

        {/* Loading Overlay */}
        {loading && (
          <div className="loading-overlay">
            <div className="loading-spinner">
              <span>{t?.('common:loading') || 'Loading...'}</span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

// Redux connection
const mapStateToProps = (state: any) => ({
  currentSettings: state.currentSettings,
  getCheckAvailableFetching: state.getCheckAvailable.fetching,
  getCheckAvailableSuccess: state.getCheckAvailable.success,
  getCheckAvailableError: state.getCheckAvailable.error,
  checkAvailable: state.getCheckAvailable.checkAvailable,
  makedata: state.createMakeUpSession.makeupdata,
});

const mapDispatchToProps = (dispatch: any) => ({
  getCheckAvailable: (
    leave_id: string,
    student_id: string,
    isTherapist: boolean,
    isReschedule: boolean,
    make_id: string,
    therapist_leave_id: string
  ) => dispatch(
    GetCheckAvailableActions.getCheckAvailableRequest(
      leave_id,
      student_id,
      isTherapist,
      isReschedule,
      make_id,
      therapist_leave_id
    )
  ),
  createMakeUpSession: (children_id: string) => dispatch(CreateMakeUpSessionActions.createMakeUpSessionRequest(children_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BookMakeUpSessionPage));
